import React, { useEffect, useRef, useState } from 'react';
import { FiXCircle } from 'react-icons/fi';
import { Flex, Box, Button, Text } from 'rebass';
import InvalidFileError from 'collections/watch-me-grow/components/InvalidFileError';
import { useMobileCheckHook } from 'story-media/hooks';
import { extensionRegex, supportedImageTypes } from 'stories/tell-a-story/FileDropperField';
import FileDropper from 'stories/tell-a-story/FileDropper';
import Editor from './Editor';

// eslint-disable-next-line react/prop-types
function AvatarEditor({ src, onDismiss, posterAttributes = null, setSubmitting, onAccept, setFile, frameSrc, setIsEditing, onImageDeletion }) {
  const [fileSrc, setFileSrc] = useState(src);
  const [dropError, setDropError] = useState([]);
  const isFromMobile = useMobileCheckHook();

  useEffect(() => {
    setFileSrc(src);
  }, [src]);

  const fileSrcRef = useRef(fileSrc);
  useEffect(() => { fileSrcRef.current = fileSrc; }, [fileSrc]);
  useEffect(() => {
    // return () => {
    //   URL.revokeObjectURL(fileSrcRef.current);
    // };
  }, []);

  return (
    <Box
      pt={posterAttributes ? [0, 2] : 2}
      sx={{
        // background: 'white',
        zIndex: 3,
        position: 'relative',
      }}
    >
      {onDismiss && (
        <Flex justifyContent="flex-end">
          <Button
            type="button"
            sx={{ cursor: 'pointer' }}
            variant="transparent"
            onClick={onDismiss}
          >
            <Text color="greys.4" as={FiXCircle} size={24} />
          </Button>
        </Flex>
      )}
      {fileSrc && (
        <Editor
          frameSrc={frameSrc}
          posterAttributes={posterAttributes}
          image={fileSrc}
          onAccept={onAccept}
          onImageDeletion={onImageDeletion}
          setSubmitting={setSubmitting}
          onClear={() => {
            setFileSrc(null)
            setIsEditing(false)
            if (onImageDeletion) onImageDeletion()
          }}
        />
      )}
      {!fileSrc && (
        <>
          <FileDropper
            accept="image/*"
            multiple={false}
            onDrop={(files) => {
              if (
                files &&
                files[0].type.includes('image') &&
                supportedImageTypes.includes(extensionRegex.exec(files[0].name)[0].toLowerCase())
              ) {
                setDropError([]);
                if (setFile) setFile(files[0]);
                setFileSrc(URL.createObjectURL(files[0]));
              } else {
                setDropError([files[0]]);
              }
            }}
          >
            {isFromMobile && (
              <Text color="greys.5">Drag an image, or click to select an image</Text>
            )}
          </FileDropper>
          <InvalidFileError
            errorFiles={dropError}
            onDismiss={() => setDropError([])}
            supportedTypes={['image']}
          />
        </>
      )}
    </Box>
  );
}

export default AvatarEditor;
